<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Simulacros</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-12">
            <div>
              <form
                class="d-none d-sm-inline-block form-inline mr-auto ml-md-12 my-4 my-md-9 mw-100 navbar-search col-md-9"
              >
                <div class="row">
                  <div class="col-4">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control bg-light border-0 small"
                        placeholder="Buscar por título"
                        aria-label="Search"
                        aria-describedby="basic-addon2"
                        v-on:keyup="loadSimulacrums"
                        v-model="search"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="this.loadSimulacrums"
                        >
                          <font-awesome-icon icon="search" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <b-form-group
                      id="input-group-3"
                      label="Estado:  "
                      label-for="input-3"
                    >
                      <b-form-select
                        id="input-3"
                        v-model="selectedStatus"
                        :options="[
                          { text: 'Activas', value: 'activas' },
                          { text: 'Inactivas', value: 'inactivas' },
                        ]"
                        required
                        @change="this.loadSimulacrums"
                        class="ml-2 mt-2"
                      ></b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-md-4" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                    <div class="text-right">
                      <router-link to="/admin-panel/simulacrums/create">
                        <b-button variant="primary">
                          <font-awesome-icon icon="fas fa-plus-square"/>&nbsp;Crear Simulacro</b-button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="simulacrumItems" :fields="fields">
              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item>
                    <router-link :to="{name: 'SimulacrumsEdit', params: { id: data.item.id },}">
                      <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                    </router-link>
                  </b-dropdown-item>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item
                    v-if="data.item.active == false"
                    @click="enableSimulacrums(data.item.id)">
                    <a href="#">
                      <font-awesome-icon icon="fas fa-check-to-slot" />&nbsp;Activar</a>
                  </b-dropdown-item>
                  </div>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item v-if="data.item.active == true" @click="disableSimulacrums(data.item.id)">
                      <a href="#">
                      <font-awesome-icon icon="fas fa-ban"/>&nbsp;Desactivar</a>
                    </b-dropdown-item>
                  </div>

                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "SimulacrumsAdmin",
  data: () => {
    return {
      fields: [
        {
          key: "title",
          sortable: true,
          label: "Título",
          class: "w-25",
        },
        {
          key: "duration",
          sortable: true,
          label: "Duración",
          class: "w-24",
        },
        {
          key: "actions",
          label: "",
          sortable: true,
          class: "w-25",
        },
      ],
      simulacrumItems: [],
      modulesInactiveItems: [],
      currentPage: 1,
      rows: 10000,
      perPage: 10,
      search: "",
      selectedStatus: "activas",
      userPermission: "",
      role: "",
      roleName: ""


    };
  },
  methods: {
    enableSimulacrums(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/enable/" + id,{simulacumId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "No se ha alcanzado el minimo de preguntas"
          );
          console.log(err.message);
          loader.hide();
        });
    },
    disableSimulacrums(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/disable/" + id,{simulacumId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        });
    },
    loadSimulacrums() {
      let tmpCurrentpage = this.$route.query.currentPage;
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/", {
          params: {
            page: this.currentPage,
            size: this.perPage,
            sort: "DESC",
            simulacrumStatus: this.selectedStatus,
            search: this.search,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loader.hide();
          this.simulacrumItems = response.data.content;
          this.rows = response.data.totalElements;
          if (this.$route.query.currentPage) {
            this.$nextTick(function () {
              this.currentPage = tmpCurrentpage;
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
  },
  loadQuery() {
      this.$nextTick(function() {
        this.$router.push({ path: '/admin-panel/simulacrum', query: { search: this.search, searchCreatedBy: this.search2, module: this.selectedModule, simulacrumPage: 1, questionsInactivePage: this.currentInactivePage, status: this.selectedStatus}});
        this.$router.go();
      });
    },
  beforeMount() {
    let auth = JSON.parse(window.localStorage.getItem("auth"));
    if (!auth.isAuthenticated) {
      window.location.href = '/'
    }
    this.userName =  auth.data.name;
    this.role = window.localStorage.getItem("role");

    if (this.role === 'ROLE_STUDENT') {
      window.location.href = '/'
    }
  },
  watch: {
    currentPage: function () {
      this.loadSimulacrums();
    },
  },
  mounted() {
    this.userPermission = localStorage.getItem("role");
    this.loadSimulacrums();
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
};
</script>

<style scoped></style>
